import { TranslateModule } from '@ngx-translate/core';
import { NgClass } from '@angular/common';

import {
  AfterViewInit, ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input,
  OnChanges, Output, SimpleChanges, ViewEncapsulation
} from '@angular/core';

import {
  ImageRatioEnum, IProductCard, SdBannerComponent, SdFormCheckboxComponent,
  SdLibConfig, SdTagComponent, SdThemeComponent, SizesEnum
} from '@seb/web-design-system/core';

import { SdReparabilityComponent } from '@seb/web-design-system/reparability';
import { SdProductLogoComponent } from '@seb/web-design-system/product-logo';
import { SdProductActionsComponent } from '@seb/web-design-system/product-actions';
import { SdProductInfoComponent } from '@seb/web-design-system/product-info';

@Component({
  selector: 'sd-product-card',
  templateUrl: './product-card.component.html',
  styleUrls: ['./product-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    NgClass,
    SdProductActionsComponent,
    SdTagComponent,
    SdProductInfoComponent,
    SdBannerComponent,
    SdReparabilityComponent,
    SdProductLogoComponent,
    SdFormCheckboxComponent,
    TranslateModule
  ]
})
export class SdProductCardComponent extends SdThemeComponent implements AfterViewInit, OnChanges {
  @Input()
  showRef = false;

  @Input()
  indexFollow = true;

  @Input()
  isLoading = false;

  @Input()
  productInfo: IProductCard;

  @Input()
  isEmbedded = false;

  @Input()
  isCompared: boolean;

  @Input()
  hasAction = true;

  /**
   * Allow to define the level of the title tag (h1 - h6).
   * * @param {number} 1 to 6
   */
  @Input()
  titleLevel = 4;

  @Input()
  largeTitle: boolean;

  /**
   * Display or not the stock
   */
  @Input()
  displayStock = true;

  @Input()
  isSmall = false;

  @Input()
  showRefurbishedLogo: boolean;

  @Input()
  isMinified = false;

  /**
   * Allow the user to defined the global layout of the component (vertical / horizontal)
   */
  @Input()
  horizontalLayout: boolean;

  @Input()
  twicPicsAutoSize = true;

  /**
   * Manage the border below the product
   */
  @Input()
  hasBorder = false;

  @Input()
  recommendedPrice: string;

  @Input()
  isBundle: boolean;

  @Input()
  isSSR = true;

  @Output()
  favorite = new EventEmitter<string>();

  @Output()
  cart = new EventEmitter<string>();

  @Output()
  notify = new EventEmitter<string>();

  @Output()
  isComparedChange = new EventEmitter<boolean>();

  @Output()
  productClicked = new EventEmitter<string>();

  @Output()
  productSellerModal = new EventEmitter<boolean>();

  @Output()
  reviewsSeeAllClicked = new EventEmitter<void>();

  @Output()
  openRecommendedPriceModal = new EventEmitter<void>();

  @Input() class = '';
  @HostBinding('class')
  get hostClasses(): string {
    return [
      this.class,
      this.isSmall ? 'is-small' : '',
      this.isEmbedded ? 'is-embedded' : '',
      this.isMinified ? 'is-minified' : '',
      this.horizontalLayout ? 'is-horizontal' : '',
      this.hasBorder ? 'has-border' : ''
    ]
      .filter(Boolean)
      .join(' ');
  }

  imageRatio: ImageRatioEnum;
  imageHasBorder: boolean;
  sizeEnum = SizesEnum;

  constructor(private sdLibConfig: SdLibConfig) {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);

    const { productImageRatio, productImageHasBorder } = this.sdLibConfig.get(this.brand);

    this.imageHasBorder = productImageHasBorder;
    this.imageRatio = productImageRatio;
  }

  ngAfterViewInit() {
    if (this.isSmall) {
      this.imageHasBorder = true;
    }
  }

  addToFavorite(): void {
    this.favorite.emit(this.productInfo.code);
  }

  addToCart(): void {
    this.cart.emit(this.productInfo.code);
  }

  stockNotify(): void {
    this.notify.emit(this.productInfo.code);
  }

  addToComparator(event: boolean): void {
    this.isComparedChange.emit(event);
  }

  onProductClick(): void {
    this.productClicked.emit(this.productInfo.code);
  }

  onReviewsSeeAllClicked(): void {
    this.reviewsSeeAllClicked.emit();
  }

  onopenRecommendedPriceModal(): void {
    this.openRecommendedPriceModal.emit();
  }
}
